import {getDefaultActivityType} from '../../core/activities/get-default-activity-type';
import {defaultDurationOption} from '../../timeline/creator/consts';

import {TAB_ACTIVITY} from '../content/action-bar/consts';

import type {LeadPageState} from './types';

export const INITIAL_LEAD_PAGE_STATE: LeadPageState = {
    creatorForm: {
        noteHtmlValue: '',
        notePlaintextValue: '',
        isActive: false,
        activityTypeId: getDefaultActivityType(),
        durationMinutes: defaultDurationOption.value,
        pinNote: false,
        isTranscribing: false,
    },
    actionBarTab: TAB_ACTIVITY,
};
